import React from 'react';
import { User, Calendar, Phone } from 'lucide-react';
import { formatDate } from '../../../utils/formatters';
import { Paciente } from '../../../types';

interface UltimosPacientesProps {
  pacientes: Paciente[];
}

const UltimosPacientes: React.FC<UltimosPacientesProps> = ({ pacientes }) => {
  const ultimosPacientes = React.useMemo(() => {
    return [...pacientes]
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
      .slice(0, 5);
  }, [pacientes]);

  return (
    <div className="grid gap-4">
      {ultimosPacientes.map((paciente) => (
        <div
          key={paciente._id}
          className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <div className="flex items-center space-x-4">
            <div className="bg-white p-2 rounded-full">
              <User className="h-5 w-5 text-blue-600" />
            </div>
            <div>
              <p className="font-medium">{paciente.nombre}</p>
              <div className="flex items-center space-x-4 text-sm text-gray-500">
                <span className="flex items-center">
                  <Calendar className="h-4 w-4 mr-1" />
                  {formatDate(paciente.fechaNacimiento)}
                </span>
                {paciente.telefono && (
                  <span className="flex items-center">
                    <Phone className="h-4 w-4 mr-1" />
                    {paciente.telefono}
                  </span>
                )}
              </div>
            </div>
          </div>
          <span className="text-sm text-gray-500">
            {formatDate(paciente.createdAt)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default UltimosPacientes;